import { usePageJsonLd } from './usePageJsonLd';
import { matchPathSegment, type PageSeoData } from './useJsonLdShared';

interface AboutUsJsonLdOptions {
  pageData: PageSeoData;
}

/**
 * Builds and injects JSON-LD structured data for the About Us page.
 * Values are dynamic based on the current locale (localization-code).
 * Only runs when the current route is the about-us page.
 */
export function useAboutUsJsonLd(options: AboutUsJsonLdOptions) {
  usePageJsonLd({
    pageData: options.pageData,
    isCurrentPage: path => matchPathSegment(path, 'about-us', { allowNested: true }),
    pageType: 'AboutPage',
    defaultTitle: 'About Us',
    pagePath: '/about-us',
    scriptKey: 'about-us-jsonld',
  });
}
